/* eslint-disable react/no-array-index-key */
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Button, Space, Table, Typography } from 'antd';
import { useState } from 'react';
import styled from 'styled-components';
import { EvidiaModal } from '../EvidiaModal/EvidiaModal';
import { SimpleForm } from './SimpleForm';
import { RepeatableField as RepeatableFieldTypes } from './SimpleFormTypes';

const FullWidth = styled.div`
	width: 100%;
	button {
		width: 100%;
	}
`;

type Props = RepeatableFieldTypes & {
	value?: any[];
	onChange?: (value: any) => void;
};

const RepeatableField: React.FC<Props> = ({ value, onChange, config, fields }) => {
	const [isOpen, setIsOpen] = useState(false);
	const onRemove = (index: number) => {
		const newValueArray = [...(value || [])];
		newValueArray.splice(index, 1);
		onChange?.(newValueArray);
	};

	const onAdd = () => {
		setIsOpen(true);
	};

	const onSecondFormFinish = (values: any) => {
		const newValueArray = [...(value || []), values];
		onChange?.(newValueArray);
		setIsOpen(false);
	};

	return (
		<>
			<EvidiaModal open={isOpen} onCancel={() => setIsOpen(false)} footer={null}>
				<Typography.Title level={4}>{config.newItemTitle}</Typography.Title>
				<SimpleForm fields={fields} onFinish={onSecondFormFinish} submitButtonTitle="Vytvořit" />
			</EvidiaModal>
			<Space direction="vertical" style={{ width: '100%' }}>
				{value?.map((v, index) => (
					<Space.Compact key={index} block>
						<Table
							size="small"
							showHeader={false}
							dataSource={[value[index]]}
							columns={config.preview.map(p => ({
								// title: p,
								dataIndex: p,
								key: p,
							}))}
							pagination={false}
						/>
						<Button danger icon={<DeleteOutlined />} onClick={() => onRemove(index)} size="large" />
					</Space.Compact>
				))}
				<FullWidth>
					<Button icon={<PlusCircleOutlined />} onClick={() => onAdd()}>
						{config.newItemTitle}
					</Button>
				</FullWidth>
			</Space>
		</>
	);
};

export default RepeatableField;
